import { Form } from "@form/Form";
import FormInput from "@form/FormInput";
import { useApi } from "../../../../hooks/useApi";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Relative } from "../types";

interface Props {
    clubSlug: string;
    relative: Relative;
    callback?: () => void;
}

// General-purpose edit form for a club relative; currently edits the free-text position.
export const EditRelativeForm: React.FunctionComponent<React.PropsWithChildren<Props>> = ({ clubSlug, relative, callback }) => {
    const { t } = useTranslation('general');
    const api = useApi();
    const [isLoading, setIsLoading] = useState(false);

    // Persist the edited fields onto the relative's pivot via the update endpoint.
    const handleSubmit = (data: { position: string }) => {
        setIsLoading(true);
        return api({
            url: `club/${clubSlug}/relatives/${relative.id}`,
            method: "PUT",
            data: { position: data.position?.trim() || null },
            onBefore: () => setIsLoading(false),
            onSuccess: callback,
        });
    };

    return (
        <Form onSubmit={handleSubmit} defaultValues={{ position: relative.position ?? "" }}>
            <FormInput name="position" label="Position" placeholder={t('permissions.editRelativeForm.positionPlaceholder')} />
            <FormInput.Submit isLoading={isLoading} />
        </Form>
    );
};
